<template>
  <div class="common-style">
    <div class="topForm">
      <a-form id="add" ref="formbook" layout="inline">
        <a-form-item label="年级">
          <a-select
            notFoundContent="暂无年级"
            placeholder="请选择"
            style="width:150px"
            v-model="defaultName"
          >
            <a-select-option
              v-for="(item, index) in stageList"
              :key="index"
              :value="item.name"
              @click="changeClass(item)"
            >{{ item.name }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="时间">
          <a-range-picker
            style="width:250px"
            :allowClear="false"
            :disabledDate="disabledDate"
            :placeholder="['开始时间', '结束时间']"
            :defaultValue="[
              moment(
                moment()
                  .subtract(7, 'days')
                  .calendar()
              ),
              moment(),
            ]"
            @change="onChangeTime"
          />
        </a-form-item>
        <a-button type="primary" @click="getMasterdata()">查询</a-button>
      </a-form>
    </div>
    <div v-if="!noData" class="analysisOnly">
      <div class="titleTop">
        <div>
          <!-- {{dataList.orgName}}教学分析
                    <span>
                        <a-range-picker style="width:225px" :allowClear="false" :placeholder="['开始时间', '结束时间']" :defaultValue="[
              moment(
                moment()
                  .subtract(7, 'days')
                  .calendar()
              ),
              moment()
            ]" @change="onChangeTime" />
                        <small>统计时间截止于{{moment().locale('zh-cn').format('YYYY-MM-DD')}} 06:00</small>
          </span>-->
          <small>
            统计时间截止于{{
            moment()
            .locale("zh-cn")
            .format("YYYY-MM-DD")
            }}
            06:00
          </small>
        </div>
      </div>
      <div class="firstUl">
        <div>
          <div class="leftDiv" style="border-right: 10px solid #19192c;">
            <ul>
              <li>
                <p>在用班级</p>
                <div>{{ dataList.classnum | PrefixInteger }}</div>
              </li>
              <li>
                <p>在用教师</p>
                <div>{{ dataList.teachernum | PrefixInteger }}</div>
              </li>
              <li>
                <p>在用学生</p>
                <div>{{ dataList.studentnum | PrefixInteger }}</div>
              </li>
            </ul>
            <div class="tableDiv">
              <div class="tableUl flexSh">
                <p v-for="(item, index) in columns" :key="index">{{ item.title }}</p>
              </div>
              <div class="tabHeight flexSh">
                <div
                  class="tableDetail"
                  v-for="(item, index) in dataList.classDataMessages"
                  :key="index"
                >
                  <p>
                    <a-tooltip>
                      <template slot="title">{{ item.className }}</template>
                      <i>{{ item.className }}</i>
                    </a-tooltip>
                  </p>
                  <p>{{ item.peopleNum }}人</p>
                  <p>{{ item.exerciseNum }}次</p>
                  <p>{{ item.submitRate | parseFloat }}%</p>
                  <p>{{ item.correctRate | parseFloat }}%</p>
                  <p>{{ item.revisionRate | parseFloat }}%</p>
                </div>
              </div>
            </div>
          </div>
          <div class="rightDiv">
            <ul>
              <li>
                <p>布置作业次数</p>
                <div>{{ dataList.allExercise | PrefixInteger }}</div>
              </li>
              <li>
                <p>布置题目数量</p>
                <div>{{ dataList.allQuestion | PrefixInteger }}</div>
              </li>
              <li>
                <p>微课观看总数</p>
                <div>{{ dataList.allMicroLesson | PrefixInteger }}</div>
              </li>
            </ul>
            <div class="graph">
              <h2>作业数量</h2>
              <div class="charts">
                <highcharts :options="optionWork" ref="highcharts"></highcharts>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="firstUl">
        <div>
          <div class="rightDiv" style="height:455px;">
            <div class="graph" style="border-right: 1px solid rgba(255, 255, 255, 0.5);">
              <h2>综合完对率</h2>
              <div class="charts">
                <highcharts :options="optionclassRate" ref="highcharts"></highcharts>
              </div>
            </div>
          </div>
          <div class="leftDiv" style="height:455px;">
            <h2>学生日均作业量</h2>
            <div class="tableDiv">
              <div class="tableUl">
                <p v-for="(item, index) in dayColumns" :key="index">
                  <a-tooltip>
                    <template slot="title">{{ item.title }}</template>
                    <i>{{ item.title }}</i>
                  </a-tooltip>
                </p>
              </div>
              <div class="dayHeight">
                <div
                  class="tableDetail"
                  v-for="(item, index) in dataList.gradeDataMessages"
                  :key="index"
                >
                  <p>{{ item.gradeName }}</p>
                  <p>{{ item.exerNum }}份</p>
                  <p>{{ item.aveExerNumDay | differDays }}份</p>
                  <p>{{ item.aveQuesNumDay | differDays }}题</p>
                  <p>{{ item.writetimecount }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="noData" class="noData" style="margin-top:100px;">
      <p>
        <img src="../../assets/images/noData.png" alt />
      </p>
    </div>
    <!-- 刷新 -->
    <div v-if="loadingList" style="position:fixed;margin-left:40%;top:55%;z-index:99;">
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
import moment from "moment"
export default {
  data () {
    return {
      noData: false,
      loadingList: true,
      stageList: [],
      defaultName: "",
      stageId: "",
      moment,
      startTime: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      endTime: moment().format("YYYY-MM-DD"),
      columns: [
        { title: "班级" },
        { title: "人数" },
        { title: "次数" },
        { title: "提交率" },
        { title: "批改率" },
        { title: "订正率" },
      ],
      dayColumns: [
        { title: "年级" },
        { title: "作业份数" },
        { title: "平均每天作业量" },
        { title: "平均每天题目量" },
        { title: "平均每天用时" },
      ],
      dataList: [],
      optionWork: {},
      optionclassRate: {},
    }
  },
  methods: {
    // 选择班级
    getClass () {
      if (this.$store.getters.stageInfoList.length > 0) {
        this.$http
          .get("v1/learnonly/teachingAssistant/getgrade", {
            params: { userid: this.$store.getters.id },
          })
          .then((response) => {
            if (response.data) {
              response.data.data.unshift({
                id: "",
                name: "全部",
              })
              this.stageList = response.data.data
              this.defaultName = response.data.data[0].name
            }
          })
      } else {
        this.$message.warning("暂未绑定班级!", 1)
        this.loadingList = false
        this.noData = true
      }
    },
    changeClass (item) {
      this.stageId = item.id
    },
    // 时间
    disabledDate (current) {
      return current && current > moment().endOf("day")
    },
    onChangeTime (date, dateString) {
      this.startTime = dateString[0]
      this.endTime = dateString[1]
    },
    //查询数据
    getMasterdata () {
      this.$http
        .get("v1/learnonly/aianalyse/headmasterdata", {
          params: {
            orgid: this.$store.getters.orgid,
            startTime: this.startTime,
            endTime: this.endTime,
            gradeid: this.stageId,
          },
        })
        .then((res) => {
          if (res.data) {
            this.loadingList = false
            this.dataList = res.data.data
            // 两日期间隔天数
            var day =
              moment(this.endTime).diff(moment(this.startTime), "days") +
              Number(1)
            for (let i in res.data.data.gradeDataMessages) {
              // 平均每天作业量
              res.data.data.gradeDataMessages[i].aveExerNumDay =
                res.data.data.gradeDataMessages[i].aveExerNum / day
              // 平均每天题目量
              res.data.data.gradeDataMessages[i].aveQuesNumDay =
                res.data.data.gradeDataMessages[i].aveQuesNum / day
              // 平均每天用时
              var milliSecond =
                res.data.data.gradeDataMessages[i].taketime / day
              var change = 1000 * 60
              var minute = milliSecond / change
              var second = (milliSecond % change) / 1000
              res.data.data.gradeDataMessages[i].writetimecount =
                Math.floor(minute) + "分" + Math.floor(second) + "秒"
            }
            // 作业数量
            var teacherData = res.data.data.teacherDataMessages
            // 平均布置作业数量水平线
            var aveTeacher = ""
            aveTeacher = res.data.data.allTeaAveExer
            var teachNumber = []
            var teachDetail = []
            for (let i = 0; i < teacherData.length; i++) {
              teachNumber.push({
                name: teacherData[i].teacherName,
                y: +teacherData[i].exerNum,
                drilldown: teacherData[i].teacherName,
              })
              teachDetail.push({
                name: teacherData[i].teacherName,
                id: teacherData[i].teacherName,
                data: [
                  ["批改率", +teacherData[i].correctRate],
                  ["订正批改率", +teacherData[i].revisionCorrectRate],
                  ["微课录制数量", +teacherData[i].microLessonCount],
                  ["微课浏览量", +teacherData[i].microPlayCount],
                  ["", 0],
                  [" ", 0],
                  ["  ", 0],
                  ["   ", 0],
                  ["    ", 0],
                  ["     ", 0],
                  ["      ", 0],
                ],
                tooltip: {
                  followPointer: true,
                  followTouchMove: false,
                },
              })
            }
            if (teachNumber.length < 11) {
              teachNumber.push(
                { name: "" },
                { name: " " },
                { name: "  " },
                { name: "   " },
                { name: "    " },
                { name: "     " },
                { name: "      " },
                { name: "       " },
                { name: "        " },
                { name: "         " },
                { name: "          " }
              )
            }
            this.optionWork = {
              chart: {
                type: "column",
                backgroundColor: "#24263e",
              },
              title: {
                text: "",
              },
              subtitle: {
                text: "点击可查看具体老师数据",
                style: {
                  color: "#fff",
                },
              },
              legend: {
                enabled: false, //  禁用图例
              },
              credits: {
                enabled: false, //不显示LOGO
              },
              scrollbar: {
                enabled: true,
                barBackgroundColor: "gray",
                barBorderRadius: 7,
                barBorderWidth: 0,
                buttonBackgroundColor: "gray",
                buttonBorderWidth: 0,
                buttonBorderRadius: 7,
                trackBackgroundColor: "none",
                trackBorderWidth: 1,
                trackBorderRadius: 8,
                trackBorderColor: "#333",
                height: 10,
              },
              xAxis: {
                type: "category",
                labels: {
                  style: {
                    color: "rgba(255,255,255,0.5)",
                  },
                },
                max: 10,
              },
              yAxis: {
                title: {
                  text: "份数",
                },
                labels: {
                  style: {
                    color: "rgba(255,255,255,0.5)",
                  },
                },
              },
              plotLines: [
                {
                  //基准线
                  color: "#8fc2ec",
                  dashStyle: "Dash",
                  width: 3,
                  value: aveTeacher.toFixed(),
                  zIndex: 5,
                  label: {
                    text: "平均布置作业数量：" + aveTeacher.toFixed(),
                    style: {
                      color: "rgba(255,255,255,0.8)",
                      fontWeight: "bold",
                    },
                  },
                  series: {
                    borderWidth: 0,
                    dataLabels: {
                      enabled: true,
                      // format: '{point.y:.1f}%'
                    },
                  },
                },
              ],
              lang: {
                drillUpText: "< 返回 {series.name}",
              },
              tooltip: {
                headerFormat:
                  '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat:
                  '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b><br/>',
              },
              series: [
                {
                  name: "",
                  colorByPoint: true,
                  data: teachNumber,
                  tooltip: {
                    valueSuffix: " 份",
                    followPointer: true,
                    followTouchMove: false,
                  },
                },
              ],
              drilldown: {
                series: teachDetail,
              },
            }
            // 综合完对率
            var classData = res.data.data.classDataMessages
            // 平均完对率水平线
            var aveScore = ""
            aveScore = res.data.data.allClassAveRight
            var classRate = []
            var rightRate = []
            var arrData = []
            // 一级数据
            for (let k = 0; k < classData.length; k++) {
              if (classData[k].exerciseNum !== 0) {
                classRate.push({
                  name: classData[k].className,
                  y: +classData[k].aveScore,
                  drilldown: classData[k].className,
                })
                for (let j = 0; j < classData[k].bankDataMessages.length; j++) {
                  classData[k].bankDataMessages[j].className =
                    classData[k].className
                  classData[k].bankDataMessages[j].name =
                    classData[k].bankDataMessages[j].bankName
                  classData[k].bankDataMessages[j].y = +classData[k]
                    .bankDataMessages[j].aveScore
                  classData[k].bankDataMessages[j].drilldown =
                    classData[k].bankDataMessages[j].className +
                    " " +
                    classData[k].bankDataMessages[j].bankName
                  var milliData = classData[k].bankDataMessages[j].aveTime
                  classData[k].bankDataMessages[j].aveTimeChange = (
                    milliData /
                    (1000 * 60)
                  ).toFixed(2)
                  arrData.push(classData[k].bankDataMessages[j])
                }
              }
            }
            if (classRate.length < 11) {
              classRate.push(
                { name: "" },
                { name: " " },
                { name: "  " },
                { name: "   " },
                { name: "    " },
                { name: "     " },
                { name: "      " },
                { name: "       " },
                { name: "        " },
                { name: "         " },
                { name: "          " }
              )
            }
            // 二级数据
            for (let k = 0; k < classData.length; k++) {
              if (classData[k].exerciseNum !== 0) {
                rightRate.push({
                  colorByPoint: true,
                  name: classData[k].className,
                  id: classData[k].className,
                  data: classData[k].bankDataMessages,
                  tooltip: {
                    valueSuffix: " %",
                    followPointer: true,
                    followTouchMove: false,
                  },
                })
              }
            }
            for (let i = 0; i < rightRate.length; i++) {
              if (rightRate[i].data.length < 11) {
                rightRate[i].data.push(
                  { name: "" },
                  { name: " " },
                  { name: "  " },
                  { name: "   " },
                  { name: "    " },
                  { name: "     " },
                  { name: "      " },
                  { name: "       " },
                  { name: "        " },
                  { name: "         " },
                  { name: "          " }
                )
              }
            }
            // 三级数据
            for (let i = 0; i < arrData.length; i++) {
              rightRate.push({
                id: arrData[i].drilldown,
                name: arrData[i].drilldown,
                colorByPoint: true,
                data: [
                  {
                    name: "布置次数",
                    y: +arrData[i].exerNum,
                  },
                  {
                    name: "题目数量",
                    y: +arrData[i].quesNum,
                  },
                  {
                    name: "平均用时",
                    y: +arrData[i].aveTimeChange,
                  },
                  {
                    name: "提交率",
                    y: +arrData[i].submitRate,
                  },
                  {
                    name: "完对率",
                    y: +arrData[i].aveScore,
                  },
                  {
                    name: "订正率",
                    y: +arrData[i].revisionRate,
                  },
                  { name: "" },
                  { name: " " },
                  { name: "  " },
                  { name: "   " },
                  { name: "    " },
                ],
                tooltip: {
                  followPointer: true,
                  followTouchMove: false,
                },
              })
            }
            this.optionclassRate = {
              chart: {
                type: "column",
                backgroundColor: "#24263e",
              },
              title: {
                text: "",
              },
              subtitle: {
                text: "点击可查看具体数据",
                style: {
                  color: "#fff",
                },
              },
              legend: {
                enabled: false, //  禁用图例
              },
              credits: {
                enabled: false, //不显示LOGO
              },
              scrollbar: {
                enabled: true,
                barBackgroundColor: "gray",
                barBorderRadius: 7,
                barBorderWidth: 0,
                buttonBackgroundColor: "gray",
                buttonBorderWidth: 0,
                buttonBorderRadius: 7,
                trackBackgroundColor: "none",
                trackBorderWidth: 1,
                trackBorderRadius: 8,
                trackBorderColor: "#CCC",
                height: 10,
              },
              xAxis: {
                type: "category",
                labels: {
                  style: {
                    color: "rgba(255,255,255,0.5)",
                  },
                },
                max: 10,
              },
              yAxis: {
                endOnTick: false,
                type: "logarithmic",
                title: {
                  text: "完对率",
                },
                labels: {
                  style: {
                    color: "rgba(255,255,255,0.5)",
                  },
                },
                max: 100,
              },
              plotLines: [
                {
                  //基准线
                  color: "#8fc2ec",
                  dashStyle: "Dash",
                  width: 3,
                  value: aveScore.toFixed(),
                  zIndex: 5,
                  label: {
                    text: "平均完对率：" + aveScore.toFixed() + "%",
                    style: {
                      color: "rgba(255,255,255,0.8)",
                      fontWeight: "bold",
                    },
                  },
                  series: {
                    borderWidth: 0,
                    dataLabels: {
                      enabled: true,
                      // format: '{point.y:.1f}%'
                    },
                  },
                },
              ],
              tooltip: {
                headerFormat:
                  '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat:
                  '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b> <br/>',
              },
              lang: {
                drillUpText: "< 返回 {series.name}",
              },
              series: [
                {
                  name: "",
                  type: "column",
                  colorByPoint: true,
                  data: classRate,
                  tooltip: {
                    valueSuffix: " %",
                    followPointer: true,
                    followTouchMove: false,
                  },
                },
              ],
              drilldown: {
                series: rightRate,
              },
            }
          } else {
            this.loadingList = false
          }
        })
    },
  },
  filters: {
    PrefixInteger (num) {
      if (num == undefined) {
        return "000000"
      } else {
        return (Array(6).join(0) + num).slice(-6)
      }
    },
    // 保留两位小数去0
    parseFloat (num) {
      var val = parseFloat(num).toFixed(2)
      return parseFloat(val)
    },
    // 2-3显示
    differDays (num) {
      if (!isNaN(num)) {
        var reg = /^\d+\.\d+$/
        if (reg.test(num)) {
          //小数
          if (num < 1 && num > 0) {
            // 小于1
            return "< 1"
          } else if (num > 1) {
            return Math.floor(num) + "-" + Math.ceil(num)
          }
        } else {
          // 正数
          return num
        }
      }
    },
  },
  mounted () {
    this.getClass()
    this.getMasterdata()
  },
}
</script>

<style lang="scss">
@import '~@/assets/css/theme.scss';
</style>

<style scoped>
/* @import url('https://m1.bdp.cn/static/pkg/shareApp-bundle_74a0ab6.css'); */
/deep/ p {
  margin: 0;
  padding: 0;
}
.topForm {
  padding: 15px;
  border-bottom: 10px solid #eee;
}
.titleTop {
  background: #19192c;
  padding: 15px;
}
.titleTop div {
  /* font-size: 21px; */
  color: rgba(255, 255, 255, 0.7);
  text-align: right;
  /* position: relative; */
}
.titleTop div > span {
  position: absolute;
  right: 15px;
  top: 5px;
  font-size: 14px;
}
/* /deep/.ant-input {
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.7);
    font-size: 20px;
}
/deep/.ant-calendar-range-picker-separator {
    color: rgba(255, 255, 255, 0.7);
} */
/* 1 */
.firstUl {
  background: #19192c;
  color: #fff;
  padding: 0 15px 15px 15px;
}
.firstUl > div {
  overflow: hidden;
  margin: 0;
}
.firstUl > div > div {
  float: left;
  width: 50%;
  background: #24263e;
  text-align: center;
}
.firstUl ul {
  display: flex;
  margin: 15px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5);
}
.firstUl ul li {
  flex: 1;
  font-size: 18px;
  padding-bottom: 10px;
}
.firstUl ul li p {
  color: rgba(255, 255, 255, 0.7);
}
.firstUl ul li div {
  letter-spacing: 5px;
}

.tableDiv {
  padding: 0 10px 15px 10px;
}
.leftDiv .tableUl {
  display: flex;
  background: #191a2c;
}
.leftDiv .tableUl p {
  flex: 1;
  color: rgba(255, 255, 255, 0.7);
  font-size: 13px;
  line-height: 32px;
  padding: 0 5px;
  border-right: 1px solid #24263e;
  text-align: center;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.flexSh p:first-child {
  flex: 2;
  overflow: hidden;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.flexSh .tableDetail p:first-child {
  flex: 2;
}
.leftDiv .tabHeight {
  height: 387px;
  overflow: auto;
}
.leftDiv .dayHeight {
  height: 353px;
  overflow: auto;
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 0;
}
.leftDiv .tableDetail {
  display: flex;
  border-bottom: 1px solid #24263e;
  background: #313449;
}
.leftDiv .tableDetail p {
  flex: 1;
  font-size: 13px;
  line-height: 32px;
  padding: 0 5px;
  border-right: 1px solid #24263e;
  text-align: center;
}
h2 {
  font-size: 16px;
  margin: 10px;
  text-align: left;
  color: #fff;
}
/* x轴颜色 */
/deep/.highcharts-drilldown-axis-label {
  fill: rgba(255, 255, 255, 0.7) !important;
}
/* 网格线 */
/deep/.highcharts-grid-line {
  fill: none;
  stroke: rgba(255, 255, 255, 0.06);
}
/deep/.highcharts-axis-line {
  fill: none;
  stroke: rgba(255, 255, 255, 0.5);
}
</style>
